import React from "react";
import { TypeAnimation } from 'react-type-animation';
import './AboutTextContainer.css';

const AboutTextContainer = () => {

    const PositionText = () => {
        return (
            <TypeAnimation
                sequence={[
                    'Systems Analyst',
                    1000,
                    'Full Stack Developer',
                    1000,
                    'Software Engineer',
                    1000,
                    'Analyst Programmer',
                    1000,
                    'Web Developer',
                    1000
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="sm:text-2xl"
            />
        )
    }

    const AboutSentence = ({text}) => {
        return (
            <div>
                {
                    text.split('').map((char, index) => (
                        <AboutChar key={index} char={char}/>
                    ))
                    
                }
            </div>
        );
    };

    const AboutChar = ({char}) => {
        return (
            <span className="blast">{char}</span>
        )
    }

    return (
        <div className ="absolute top-1/2 left-[10%] w-3/4">
            <div className="font-bold text-2xl sm:text-4xl md:text-5xl lg:text-6xl">
                <AboutSentence text="Hello world,"/>
                <AboutSentence text="I'm Jarvis Tse"/>
            </div>
            <PositionText/>
        </div>
    );
}

export default AboutTextContainer;